export default __webpack_public_path__ + "static/media/tete53.79c14587.png";